import React from 'react';
import './OrganizationSkeleton.css';

const OrganizationSkeleton = () => {
  const rows = Array.from({ length: 8 });

  return (
    <div className="org-mng-skel-container">
      <div className="org-mng-skel-header">
        <div className="org-mng-skel-title" />
        <div className="org-mng-skel-actions">
          <div className="org-mng-skel-search">
            <div className="org-mng-skel-search-icon" />
            <div className="org-mng-skel-search-bar" />
          </div>
          <div className="org-mng-skel-filter" />
          <div className="org-mng-skel-button" />
        </div>
      </div>

      <div className="org-mng-skel-table">
        <div className="org-mng-skel-thead">
          <div className="org-mng-skel-th" />
          <div className="org-mng-skel-th" />
          <div className="org-mng-skel-th" />
          <div className="org-mng-skel-th" />
          <div className="org-mng-skel-th" />
          <div className="org-mng-skel-th" />
        </div>
        <div className="org-mng-skel-tbody">
          {rows.map((_, idx) => (
            <div className="org-mng-skel-tr" key={idx}>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-avatar" />
                <div className="org-mng-skel-line md" />
              </div>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-line sm" />
              </div>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-line sm" />
              </div>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-line md" />
              </div>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-badge" />
              </div>
              <div className="org-mng-skel-td">
                <div className="org-mng-skel-line xs" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrganizationSkeleton;
